import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database"; // ✅ Import Realtime Database

const firebaseConfig = {
  apiKey: "AIzaSyDD6nVUaMAappLnGJst8ddyW_V0_3KTOyw",
  authDomain: "kenwood-b4bcc.firebaseapp.com",
  databaseURL: "https://kenwood-b4bcc-default-rtdb.firebaseio.com",
  projectId: "kenwood-b4bcc",
  storageBucket: "kenwood-b4bcc.firebasestorage.app",
  messagingSenderId: "1002788523943",
  appId: "1:1002788523943:web:d7e014dcc42b30bdea7082",
  measurementId: "G-K4P5EMTGB1",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const database = getDatabase(app); // ✅ Initialize Realtime Database

export { database }; // ✅ Export the database
